import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsGetStartedRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-get-started',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/get-started',
	exact: true,
};
